export const CX_TYPES = {
    NPS: 'nps',
    CES: 'ces',
    CSAT: 'csat',
};
